<div id="border" *ngIf="!isDisabled"></div>
<ng-container *ngIf="liftCount && !isDisabled">
  <div id="liftBox" [style.right]="(100 - liftRate * 100).toString() + '%'"></div>
</ng-container>
<ng-container *ngIf="hitCount && !isDisabled">
  <div id="hitBox" [style.left]="(100 - hitRate * 100).toString() + '%'"></div>
</ng-container>
